export class WorkflowProcessStatus {
    Code: string;
    Name: string;
}